export const tickerItems = [
  '顶流男演员L某片场迟到风波 · 热度 98.6万',
  '带货主播Y某直播间翻车 · 热度 90.3万',
  '某手机品牌发布会演示争议 · 热度 81.2万',
  '连锁餐饮品牌加盟商维权 · 热度 72.5万',
  '选秀偶像组合V商演传闻 · 热度 74.2万',
  '美食博主C某探店摆拍争议 · 热度 66.8万',
  '国民女歌手S某综艺剪辑争议 · 热度 65.1万',
  'AI公司前员工数据来源爆料 · 热度 59.7万',
  '美妆品牌成分表改动讨论 · 热度 58.3万',
  '古装剧女主H某替身争议 · 热度 51.2万',
];

export const heroStats = [
  { value: '3,240', label: '已收录话题' },
  { value: '128', label: '今日更新条数' },
  { value: '62', label: '全网合集期数' },
];

export const heroTags = ['热点黑料榜单', 'TOP10排行', '全网合集', '最全整理'];

export const rankingCategories = [
  { key: 'all', label: '综合榜' },
  { key: 'ent', label: '娱乐圈' },
  { key: 'creator', label: '网红圈' },
  { key: 'tech', label: '科技圈' },
  { key: 'biz', label: '商界' },
];

export const categoryEntries = [
  {
    key: 'ent',
    name: '娱乐圈',
    desc: '片场、剧组、综艺与艺人声明类话题',
    count: 31,
    latest: '古装剧女主H某替身争议',
    icon: 'ri-movie-2-line',
  },
  {
    key: 'creator',
    name: '网红圈',
    desc: '直播、探店、账号运营与商务合作类话题',
    count: 28,
    latest: '旅行博主账号停更半月',
    icon: 'ri-vidicon-2-line',
  },
  {
    key: 'tech',
    name: '科技圈',
    desc: '发布会、参数口径与从业者爆料类话题',
    count: 21,
    latest: 'AI 公司前员工数据来源爆料',
    icon: 'ri-cpu-line',
  },
  {
    key: 'biz',
    name: '商界',
    desc: '加盟、合约、供应链与品牌回应类话题',
    count: 16,
    latest: '连锁餐饮品牌加盟商维权风波',
    icon: 'ri-store-2-line',
  },
];

export const rankingItems = [
  {
    id: 'rk01',
    category: 'ent',
    title: '顶流男演员L某片场迟到风波，剧组人员爆料细节流出',
    summary: '多个剧组账号前后发文，时间线互相矛盾，网友整理出三个关键疑点。',
    tags: ['片场', '人设争议', '剧组'],
    heat: 986500,
    updatedAt: '09:30',
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20folded%20newspapers%20with%20a%20bright%20red%20seal%20stamp%20on%20top%20of%20a%20cream%20desk%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-01&orientation=squarish',
  },
  {
    id: 'rk02',
    category: 'creator',
    title: '带货主播Y某直播间翻车，商品详情与实际不符被刷屏',
    summary: '当晚直播间评论量翻倍，品牌方随后下架相关链接并发布说明。',
    tags: ['带货', '直播翻车', '品牌回应'],
    heat: 903200,
    updatedAt: '09:12',
    cover:
      'https://readdy.ai/api/search-image?query=shopping%20cart%20filled%20with%20crumpled%20paper%20receipts%20under%20a%20warm%20spotlight%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-02&orientation=squarish',
  },
  {
    id: 'rk03',
    category: 'tech',
    title: '某手机品牌发布会演示视频被指后期合成，官方深夜致歉',
    summary: '技术博主逐帧比对后提出质疑，官方承认演示片段经过剪辑处理。',
    tags: ['发布会', '演示争议', '官方致歉'],
    heat: 812600,
    updatedAt: '08:55',
    cover:
      'https://readdy.ai/api/search-image?query=smartphone%20launch%20stage%20with%20empty%20podium%20and%20red%20backdrop%20lights%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-03&orientation=squarish',
  },
  {
    id: 'rk04',
    category: 'creator',
    title: '选秀偶像组合V被曝私下接商演，粉丝后援会连夜发声明',
    summary: '粉丝后援会与经纪公司说法不一致，事件在超话内持续发酵。',
    tags: ['商演', '后援会', '声明'],
    heat: 742100,
    updatedAt: '09:40',
    cover:
      'https://readdy.ai/api/search-image?query=stage%20spotlight%20shining%20on%20an%20empty%20microphone%20stand%20with%20red%20curtain%20behind%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-04&orientation=squarish',
  },
  {
    id: 'rk05',
    category: 'biz',
    title: '连锁餐饮品牌加盟商维权风波，总部称合同条款清晰',
    summary: '双方围绕加盟费与供货价格各执一词，多地门店状态成为关注点。',
    tags: ['加盟', '维权', '餐饮'],
    heat: 725400,
    updatedAt: '08:30',
    cover:
      'https://readdy.ai/api/search-image?query=restaurant%20menu%20and%20contract%20papers%20stacked%20on%20a%20cream%20counter%20with%20a%20red%20pen%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-05&orientation=squarish',
  },
  {
    id: 'rk06',
    category: 'creator',
    title: '美食博主C某探店视频被指摆拍，合作餐厅连夜删帖',
    summary: '网友比对拍摄角度与实景后提出疑问，账号方暂未正面回应。',
    tags: ['探店', '摆拍', '删帖'],
    heat: 668900,
    updatedAt: '09:05',
    cover:
      'https://readdy.ai/api/search-image?query=camera%20tripod%20and%20a%20styled%20plate%20of%20food%20set%20up%20for%20a%20photo%20shoot%20on%20a%20cream%20table%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-06&orientation=squarish',
  },
  {
    id: 'rk07',
    category: 'ent',
    title: '国民女歌手S某综艺剪辑争议，正片与花絮内容对不上',
    summary: '两版素材的对话顺序不一致，节目组回应称属于正常剪辑需要。',
    tags: ['综艺', '剪辑', '争议'],
    heat: 651300,
    updatedAt: '08:48',
    cover:
      'https://readdy.ai/api/search-image?query=film%20editing%20timeline%20on%20a%20screen%20with%20red%20markers%20in%20a%20warm%20dim%20studio%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-07&orientation=squarish',
  },
  {
    id: 'rk08',
    category: 'tech',
    title: 'AI公司前员工爆料内部数据来源，行业合规话题升温',
    summary: '相关帖子已被删除，但截图在多个技术社区持续传播。',
    tags: ['AI', '数据来源', '合规'],
    heat: 597800,
    updatedAt: '09:20',
    cover:
      'https://readdy.ai/api/search-image?query=server%20room%20cables%20and%20a%20single%20amber%20warning%20lamp%20in%20warm%20darkness%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-08&orientation=squarish',
  },
  {
    id: 'rk09',
    category: 'biz',
    title: '知名美妆品牌被曝成分表改动，检测报告成讨论焦点',
    summary: '消费者晒出新旧包装对比，品牌方发布长文说明配方调整原因。',
    tags: ['美妆', '成分表', '检测'],
    heat: 583200,
    updatedAt: '08:15',
    cover:
      'https://readdy.ai/api/search-image?query=cosmetic%20bottles%20and%20a%20magnifying%20glass%20on%20a%20cream%20marble%20surface%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-09&orientation=squarish',
  },
  {
    id: 'rk10',
    category: 'ent',
    title: '古装剧女主H某替身争议再起，片方放出花絮回应',
    summary: '花絮中出现了完整动作镜头，但网友对拍摄时间提出新的疑问。',
    tags: ['古装剧', '替身', '花絮回应'],
    heat: 512700,
    updatedAt: '09:35',
    cover:
      'https://readdy.ai/api/search-image?query=vintage%20television%20set%20with%20static%20screen%20in%20a%20dark%20room%20lit%20by%20amber%20light%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-10&orientation=squarish',
  },
  {
    id: 'rk11',
    category: 'creator',
    title: '百万粉丝旅行博主账号停更半月，团队解散传闻发酵',
    summary: '账号主页简介已更换，商务联系方式同步下线，引发多方猜测。',
    tags: ['账号停更', '团队变动', '传闻'],
    heat: 487400,
    updatedAt: '08:40',
    cover:
      'https://readdy.ai/api/search-image?query=abandoned%20ring%20light%20and%20phone%20on%20a%20desk%20with%20dust%20in%20warm%20amber%20light%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-11&orientation=squarish',
  },
  {
    id: 'rk12',
    category: 'tech',
    title: '新能源车企高管言论引发车主集体讨论，官方回应已沟通',
    summary: '相关言论被截取传播，完整视频发布后讨论方向出现明显分化。',
    tags: ['新能源车', '高管言论', '官方回应'],
    heat: 466300,
    updatedAt: '09:48',
    cover:
      'https://readdy.ai/api/search-image?query=electric%20car%20charging%20cable%20coiled%20on%20a%20cream%20concrete%20floor%20with%20red%20markings%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-12&orientation=squarish',
  },
  {
    id: 'rk13',
    category: 'biz',
    title: '跨境电商平台大促规则调整，卖家集体吐槽结算周期',
    summary: '规则更新公告发布后，多个卖家社群整理出受影响的主要类目。',
    tags: ['跨境电商', '大促规则', '结算'],
    heat: 452900,
    updatedAt: '08:05',
    cover:
      'https://readdy.ai/api/search-image?query=shipping%20boxes%20and%20a%20laptop%20showing%20sales%20charts%20on%20a%20warm%20wooden%20desk%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-13&orientation=squarish',
  },
  {
    id: 'rk14',
    category: 'creator',
    title: '颜值博主M某滤镜争议，线下活动生图流出引发讨论',
    summary: '活动官方图与现场图的差异被放大对比，评论区观点两极。',
    tags: ['滤镜', '生图', '讨论'],
    heat: 421000,
    updatedAt: '09:25',
    cover:
      'https://readdy.ai/api/search-image?query=phone%20screen%20with%20a%20beauty%20filter%20glow%20reflected%20on%20a%20cream%20studio%20wall%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-14&orientation=squarish',
  },
  {
    id: 'rk15',
    category: 'tech',
    title: '某游戏大厂裁员传闻发酵，员工发帖还原时间线',
    summary: '多个项目组被提及，官方暂未就传闻内容作出正式说明。',
    tags: ['游戏行业', '裁员传闻', '时间线'],
    heat: 388500,
    updatedAt: '08:22',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20office%20desks%20with%20cardboard%20boxes%20in%20warm%20afternoon%20light%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-15&orientation=squarish',
  },
  {
    id: 'rk16',
    category: 'biz',
    title: '某电商主播与品牌方合约纠纷，双方各执一词',
    summary: '品牌方晒出合同截图，主播方回应称条款存在理解差异。',
    tags: ['合约纠纷', '主播', '品牌方'],
    heat: 371600,
    updatedAt: '09:02',
    cover:
      'https://readdy.ai/api/search-image?query=pen%20and%20signed%20contract%20documents%20scattered%20on%20a%20cream%20table%20with%20a%20red%20stamp%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=300&height=300&seq=hl-rk-16&orientation=squarish',
  },
];

export const collections = [
  {
    id: 'col01',
    title: '本周娱乐圈争议合集',
    desc: '把一周内讨论度最高的片场、综艺与剧组话题按时间顺序串成一条线。',
    episodes: 24,
    updatedAt: '今日 09:40 更新',
    tag: '娱乐圈',
    cover:
      'https://readdy.ai/api/search-image?query=wall%20of%20framed%20magazine%20covers%20in%20cream%20and%20red%20tones%2C%20editorial%20gallery%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-01&orientation=landscape',
  },
  {
    id: 'col02',
    title: '直播间翻车名场面盘点',
    desc: '从口误到货不对板，把带货直播里最容易复盘的翻车节点整理成册。',
    episodes: 18,
    updatedAt: '今日 09:12 更新',
    tag: '网红圈',
    cover:
      'https://readdy.ai/api/search-image?query=row%20of%20vintage%20televisions%20showing%20static%20with%20warm%20red%20light%20spilling%20on%20the%20floor%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-02&orientation=landscape',
  },
  {
    id: 'col03',
    title: '科技发布会翻车合集',
    desc: '演示视频、参数口径与现场演示失误，逐条列出可核对的公开信息。',
    episodes: 15,
    updatedAt: '昨日 21:30 更新',
    tag: '科技圈',
    cover:
      'https://readdy.ai/api/search-image?query=cluttered%20newsroom%20desk%20with%20typewriter%2C%20coffee%20and%20red%20marker%20notes%20at%20golden%20hour%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-03&orientation=landscape',
  },
  {
    id: 'col04',
    title: '网红摆拍争议大赏',
    desc: '探店、旅拍与探班场景的摆拍质疑，保留原始截图与前后对比。',
    episodes: 21,
    updatedAt: '今日 09:05 更新',
    tag: '网红圈',
    cover:
      'https://readdy.ai/api/search-image?query=three%20empty%20director%20chairs%20under%20a%20single%20spotlight%20on%20a%20dark%20stage%20with%20cream%20backdrop%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-04&orientation=landscape',
  },
  {
    id: 'col05',
    title: '商界维权事件时间线',
    desc: '加盟、供货与合同纠纷类话题，按当事方发声顺序整理成完整时间轴。',
    episodes: 12,
    updatedAt: '昨日 19:10 更新',
    tag: '商界',
    cover:
      'https://readdy.ai/api/search-image?query=timeline%20of%20pinned%20photos%20and%20red%20strings%20on%20a%20cream%20investigation%20board%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-05&orientation=landscape',
  },
  {
    id: 'col06',
    title: '年度综艺剪辑争议全收录',
    desc: '正片与花絮不一致的经典案例，附上节目组回应与后续处理结果。',
    episodes: 16,
    updatedAt: '今日 08:48 更新',
    tag: '娱乐圈',
    cover:
      'https://readdy.ai/api/search-image?query=film%20editing%20software%20timeline%20on%20a%20large%20screen%20with%20red%20markers%20in%20a%20warm%20dim%20studio%2C%20editorial%20magazine%20collage%20style%2C%20warm%20cream%20paper%20texture%20background%2C%20bold%20crimson%20red%20and%20amber%20gold%20accents%2C%20halftone%20print%20texture%2C%20dramatic%20spotlight%20and%20deep%20shadows%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark%2C%20clean%20centered%20composition&width=640&height=420&seq=hl-col-06&orientation=landscape',
  },
];

export const topicWall = [
  { name: '片场争议', heat: 986500, level: 'hot' },
  { name: '直播翻车', heat: 903200, level: 'hot' },
  { name: '发布会演示', heat: 812600, level: 'hot' },
  { name: '后援会声明', heat: 742100, level: 'hot' },
  { name: '加盟维权', heat: 725400, level: 'hot' },
  { name: '探店摆拍', heat: 668900, level: 'warm' },
  { name: '综艺剪辑', heat: 651300, level: 'warm' },
  { name: '数据来源', heat: 597800, level: 'warm' },
  { name: '成分表改动', heat: 583200, level: 'warm' },
  { name: '替身争议', heat: 512700, level: 'warm' },
  { name: '账号停更', heat: 487400, level: 'warm' },
  { name: '高管言论', heat: 466300, level: 'normal' },
  { name: '大促规则', heat: 452900, level: 'normal' },
  { name: '滤镜争议', heat: 421000, level: 'normal' },
  { name: '裁员传闻', heat: 388500, level: 'normal' },
  { name: '合约纠纷', heat: 371600, level: 'normal' },
  { name: '品牌致歉', heat: 344200, level: 'normal' },
  { name: '花絮回应', heat: 318700, level: 'normal' },
  { name: '直播回放', heat: 296400, level: 'normal' },
  { name: '超话讨论', heat: 271800, level: 'normal' },
  { name: '删帖记录', heat: 254100, level: 'normal' },
  { name: '参数口径', heat: 238600, level: 'normal' },
  { name: '商务合作', heat: 221300, level: 'normal' },
  { name: '时间线整理', heat: 205900, level: 'normal' },
];

export const topicRising = [
  { name: '演示视频逐帧比对', delta: '+312%' },
  { name: '加盟合同条款解读', delta: '+268%' },
  { name: '直播间回放定位', delta: '+197%' },
  { name: '花絮与正片对照', delta: '+154%' },
  { name: '成分表新旧对比', delta: '+121%' },
];

export const trustPoints = [
  {
    icon: 'ri-links-line',
    title: '公开信息为主',
    desc: '条目内容以公开渠道可查的发言、公告与截图为基础，标注收集时间。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日两次更新',
    desc: '上午与晚间各整理一轮，热度变化会同步到榜单排序中。',
  },
  {
    icon: 'ri-edit-2-line',
    title: '支持纠错反馈',
    desc: '发现信息滞后或有误，可通过投稿入口提交，核对后会修订条目。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '不针对个人',
    desc: '站点仅做公开信息聚合与时间线梳理，不对任何一方作出定性判断。',
  },
];

export const faqs = [
  {
    q: '热点黑料榜单是每天更新的吗？',
    a: '是的，榜单每天更新两轮。上午 09:00 前后完成第一轮整理，晚间 21:00 前后完成第二轮，热度值会随讨论量变化重新排序。',
  },
  {
    q: 'TOP10 的排序依据是什么？',
    a: '排序主要参考公开讨论量、话题扩散速度与新增信息条数三项指标，综合计算后得到一个热度值，热度值越高排名越靠前。',
  },
  {
    q: '合集和榜单有什么区别？',
    a: '榜单展示的是当下热度最高的单条话题，合集则把同一类话题按时间顺序串成完整脉络，适合想一次性看全整个过程的使用者。',
  },
  {
    q: '话题墙里的标签是怎么来的？',
    a: '标签从条目关键词中自动汇总，同一标签下的条目越多、讨论越集中，标签显示得越醒目，点击标签可以筛选出相关条目。',
  },
  {
    q: '可以投稿或者指出内容问题吗？',
    a: '可以。页面底部的投稿入口支持提交线索与纠错信息，我们会在核对公开来源后决定是否补充或修订对应条目。',
  },
];

export const submitNotices = ['注明来源链接', '附上时间点', '避免主观定性', '同一线索不重复提交'];

export const footerColumns = [
  {
    title: '榜单入口',
    links: ['今日 TOP10', '热度上升榜', '昨日回顾', '本周总榜'],
  },
  {
    title: '合集专区',
    links: ['娱乐圈合集', '网红圈合集', '科技圈合集', '商界合集'],
  },
  {
    title: '话题墙',
    links: ['片场争议', '直播翻车', '发布会对标', '合约纠纷'],
  },
  {
    title: '关于本站',
    links: ['更新说明', '纠错与反馈', '免责声明', '投稿须知'],
  },
];